import { Box, Typography } from "@mui/material";
import BulletListEditor from "../BulletListEditor";

function ActivationPointsStep({ points, draft, setDraft, onAdd, onRemove }) {
  return (
    <Box sx={{ maxWidth: 560 }}>
      <Typography sx={{ fontSize: 14, color: "rgba(255,255,255,0.6)", mb: 2 }}>
        Add the key points this activation must hit.
      </Typography>
      <BulletListEditor
        items={points}
        draft={draft}
        setDraft={setDraft}
        onAdd={onAdd}
        onRemove={onRemove}
        placeholder="e.g. Hook must be visual"
      />
    </Box>
  );
}

export default ActivationPointsStep;